/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampCategoryDto2 } from '../../models/camp-category-dto-2';
import { CampCategoryShowResponse2 } from '../../models/camp-category-show-response-2';

export interface PatchCampCategoryUpdate$Params {
  name: string;
      body: CampCategoryDto2
}

export function patchCampCategoryUpdate(http: HttpClient, rootUrl: string, params: PatchCampCategoryUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampCategoryShowResponse2>> {
  const rb = new RequestBuilder(rootUrl, patchCampCategoryUpdate.PATH, 'patch');
  if (params) {
    rb.path('name', params.name, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampCategoryShowResponse2>;
    })
  );
}

patchCampCategoryUpdate.PATH = '/v1/camp-category/{name}';
